import { useState } from 'react';
import { useTranslatedContent } from '../useTranslatedContent';
import { EmailService } from '../../services/email/emailService';
import { validateTrainingRequest } from '../../services/email/utils/emailValidation';
import { trackConversion } from '../../utils/tracking/adsTracking';
import type { TrainingFormData } from '../../types/training';

const initialFormData: TrainingFormData = {
  name: '',
  email: '',
  company: '',
  participants: '',
  trainingType: '',
  preferredDate: '',
  message: ''
};

export const useTrainingForm = () => {
  const { t } = useTranslatedContent('training');
  const [formData, setFormData] = useState<TrainingFormData>(initialFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateTrainingRequest(formData)) {
      setError(t('request.validation'));
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await EmailService.sendTrainingRequest(formData);
      setSuccess(true);
      setFormData(initialFormData);
      trackConversion('trainingRequest');
    } catch (err) {
      console.error('Training request error:', err);
      setError(t('request.error'));
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError(null);
  };

  return {
    formData,
    loading,
    error,
    success,
    handleSubmit,
    handleChange
  };
};